import tokenManager from "./tokenManager";

// Synchronous read of the current user's roles from the decoded token. This is
// NOT a React hook — there's no reactive state — so it's safe to call from
// plain utilities, event handlers and conditionals, not just during render.
export const getRoles = () => {
  return tokenManager.getUserData()?.roles;
};

export default getRoles;
